import { Alert } from '@stratascratch/ui'
import { Plotly, VisualExecutionResults } from '@stratascratch/code-editor'

interface Props {
  results: VisualExecutionResults
}

function VisualOutput({ results }: Props) {
  const matplotImg = results.user_results?.results?.image
  if (matplotImg) {
    return (
      <div>
        <h4 className="text-lg font-bold">Output</h4>
        <img
          src={`data:image/png;base64,${matplotImg}`}
          alt="Matplotlib Result"
        />
      </div>
    )
  }

  const plotlyData = results.user_results?.results?.plotly
  if (plotlyData) {
    return (
      <div>
        <h4 className="text-lg font-bold">Output</h4>
        <Plotly data={plotlyData.data} layout={plotlyData.layout} />
      </div>
    )
  }

  return <Alert type="info">No visual result</Alert>
}

function Validation({ results }: Props) {
  const isCorrect = results.is_correct
  const diffScore = results.results_diff?.score
  const diffThreshold = results.results_diff?.threshold
  const wasResized = results.results_diff?.was_resized

  return (
    <>
      {!isCorrect && (
        <Alert type="danger" noIcon className="text-center">
          Solution is incorrect.
          <br />
          For a solution to be accepted the values in your graph should match
          the expected solution values. Titles, labels, and colors are ignored
          in the evaluation.
        </Alert>
      )}
      {isCorrect && (
        <Alert type="success" noIcon>
          Solution is correct!
        </Alert>
      )}
      {diffScore && diffThreshold && (
        <Alert type="info" noIcon className="text-center">
          Your Image Similarity Measurement: {diffScore}.
          <br />
          The threshold to meet or exceed is {diffThreshold}.
          {wasResized && (
            <>
              <br />
              Please refer to the figsize(n,m) code in the Question description.
            </>
          )}
        </Alert>
      )}
      <VisualOutput results={results} />
    </>
  )
}

export default function VisualResults({ results }: Props) {
  const executionError = results?.error

  if (executionError) {
    return (
      <Alert type="danger" noIcon>
        {executionError}
      </Alert>
    )
  }

  if (results.is_solution_validation) {
    return (
      <>
        <Validation results={results} />
        <VisualOutput results={results} />
      </>
    )
  }

  return <VisualOutput results={results} />
}
